import { darkBackgroundBlur } from '@src/components/utilities';
import { themeStyle } from '@src/theming';
import styled from 'styled-components';

export const TooltipWrapper = styled.div<{
  isPositioned: boolean;
  maxWidth?: string;
  theme?: Partial<{
    fontSize: string;
    lineHeight: string;
    textAlign: string;
  }>;
}>`
  position: absolute;
  padding: 4px 8px;
  background-color: ${themeStyle.varInkMain};
  color: ${themeStyle.varInkBase};
  font-weight: ${themeStyle.fontMedium};
  font-size: ${({ theme }): string => theme?.fontSize ?? themeStyle.fontSize11};
  line-height: ${({ theme }): string => theme?.lineHeight ?? 'unset'};
  border-radius: ${themeStyle.radiusSmall};
  box-shadow: ${themeStyle.varShadowHeavy};
  z-index: var(--z-index-tooltip);
  opacity: ${({ isPositioned }): string => (isPositioned ? '1' : '0')};
  transition: opacity 225ms;
  text-align: ${({ theme }): string => theme?.textAlign ?? 'center'};
  max-width: ${({ maxWidth }): string => (maxWidth ? maxWidth : 'unset')};

  ${darkBackgroundBlur};
  html[data-theme='dark'] &&,
  .dark && {
    background-color: ${themeStyle.varBackgroundAlt};
    color: ${themeStyle.varInkMain};
  }

  @media (hover: none) {
    display: none;
  }
`;
